import { connect } from "react-redux";
import Subscription from "./subscription";
import {
	subscriptionFetch,
	onAddPayment,
	onAddPaymentClose,
	onCancelSubscription,
	subscriptionExtendRequest,
	subscriptionExtendSuccess,
	subscriptionExtendFailed,
} from "../../actions";

const mapStateToProps = ({ subscription, profile, staff, organisations }) => ({
	subscription: subscription,
	role: profile.role,
	staffList: staff.pagination.results,
	currentOrganisationGUID: organisations.currentOrganisation,
});

const mapDispatchToProps = {
	onFetchSubscription: subscriptionFetch,
	onOpenAddPaymentModal: onAddPayment,
	onCloseAddPaymentModal: onAddPaymentClose,
	onCancelSubscription: onCancelSubscription,
	onExtendRequest: subscriptionExtendRequest,
	onExtendSuccess: subscriptionExtendSuccess,
	onExtendFailed: subscriptionExtendFailed,
};

export default connect(mapStateToProps, mapDispatchToProps)(Subscription);
